import styled, { css } from 'styled-components';

export interface ButtonAtributesProps {
  buttonType?: 'success' | 'warning' | 'info' | 'primary' | 'error' | 'outline';
  borderColor?: string;
  textColor?: string;
  textSize?: string;
}

export const Root = styled.div<ButtonAtributesProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  width: 100%;

  transition: background-color 0.2s;

  padding: 0 15px;
  background: #fff;
  border: 1px solid #e1e1e1;
  color: #000;
  &:hover {
    border-radius: 10px;
    border: 1px solid var(--primary);
  }
`;

export const Container = styled.div<ButtonAtributesProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  border: 0;
  width: 100%;
  height: 56px;
  font-weight: 500;

  svg {
    margin-left: 6px;
    margin-right: 6px;
  }

  .btnGoogle {
    margin: 5px;
    width: 255px;
    height: 35px;
    border-radius: 4px;
    background: #fff !important;
    color: var(--primary) !important;
    border: none !important;
    text-align: center;
    box-shadow: none !important;
    font-size: 16px !important;
    text-transform: uppercase;
    font-weight: 700;
    justify-content: center;
  }

  .btnGoogle:hover {
    background: #db3236;
    opacity: 0.6;
  }

  ${props =>
    props.textColor &&
    css`
      .btnGoogle {
        color: ${props.textColor} !important;
      }

      bottom {
        span {
          color: ${props.textColor};
        }
      }
    `}

  ${props =>
    props.textSize &&
    css`
      .btnGoogle {
        font-size: ${props.textSize} !important;
      }

      bottom {
        span {
          font-size: ${props.textSize};
        }
      }
    `}
`;

export const ContainerIcone = styled.div``;
